module.exports = __webpack_public_path__ + "static/media/icon4.e48e48f3.svg";